import { useStaticQuery } from "gatsby";
export var useSeo = function useSeo() {
    return useStaticQuery("1132069882");
};
